import { useEffect } from "react";
import { BACKGROUND_COLORS } from "../constants/backgroundColors";
import { useViewSettingsStore } from "../stores/viewSettings";

export function useDarkModeSync() {
  const backgroundColor = useViewSettingsStore((s) => s.backgroundColor);

  useEffect(() => {
    const isDark = BACKGROUND_COLORS[backgroundColor]?.isDark ?? false;
    document.documentElement.classList.toggle("dark", isDark);
  }, [backgroundColor]);
}
